import type { DashboardTemplate } from './dashboardTemplate.types';

// Six components covering the three types the other two templates leave out: an embedded table, a
// ranked list and a narrative content card. Together with `totals` and `charts` this reaches all
// seven registered component types.
//
// "The LTM EV/Revenue multiple" is `implied_ev_ltm_revenue`, a ratio metric (summed enterprise value
// over summed total revenue) — hence asking for it as a multiplier rather than a currency. The list
// caps at 5, comfortably inside the registry's limit of 10.
export const valuationsTemplate: DashboardTemplate = {
  id: 'valuations',
  title: 'Valuation Review',
  description: 'Valuation cards above a portfolio table, a ranked list and a narrative card.',
  prompt: `Build a valuation review dashboard on a 3-column layout.

Open with three 1x1 totals cards — equity value, enterprise value, and the LTM EV/Revenue multiple as a multiplier — each with a "vs prior period" comparison.

Below them a full-width table grouped by company with columns for company name, invested capital, total value, MOIC and gross IRR, sorted by total value descending.

Finish with a 1-wide list of the top 5 companies by MOIC, beside a 2-wide content card titled "Valuation Notes" with an "On Track" badge and a short description.`,
  preview: [{ w: 1 }, { w: 1 }, { w: 1 }, { w: 3 }, { w: 1 }, { w: 2 }],
};
